<template>
  <v-dialog v-model="dialog"
            max-width="90%">
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left
                  color="white">
            fas fa-fw fa-sparkles
          </v-icon>
          Mobile Locker AI
        </v-card-title>
        <v-card-text v-if="form.busy"
                     class="d-flex flex-column pa-4">
          <div class="d-flex justify-center mb-4">
            <v-progress-circular indeterminate
                                 size="60">
            </v-progress-circular>
          </div>
          <div class="d-flex justify-center">
            Generating subject lines
          </div>
        </v-card-text>
        <v-card-text v-else
                     class="pa-4">
          <v-text-field v-model="form.subject"
                        label="Subject"
                        outlined
                        dense
                        hide-details>
          </v-text-field>

          <v-subheader class="pl-0">
            Suggestions:
          </v-subheader>
          <v-list v-if="suggestions.length"
                  dense
                  class="border-gray-light border-bottom-none py-0">
            <template v-for="suggestion in suggestions">
              <v-list-item :key="suggestion.id"
                           dense>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ suggestion.value }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ suggestion.explanation }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click.prevent="selectSubject(suggestion.value)"
                         small>
                    Use
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-list>

          <ErrorAlert v-if="error"
                      :error="error">
          </ErrorAlert>
        </v-card-text>
        <v-card-actions v-if="form.busy === false">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Generate different suggestions
          </v-btn>
          <v-btn @click.prevent="close"
                 :disabled="form.busy">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import {Form} from 'vform';
import ErrorAlert from '../../../components/ErrorAlert.vue';

export default {
  components: {ErrorAlert},
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      form: new Form({
        index: this.index,
        subject: this.subject,
      }),
      suggestions: [],
    }
  },
  created() {
    this.submit();
  },
  methods: {
    async submit() {
      if (this.form.busy) {
        return;
      }
      try {
        this.error = null;
        this.form.startProcessing();
        this.suggestions = await shareTemplateService.suggestSubjectLine(this.form.subject);
        this.form.finishProcessing();
      } catch (e) {
        this.error = e;
      } finally {
        this.form.busy = false;
      }
    },
    selectSubject(subject) {
      this.$emit('close', subject);
    },
    close() {
      this.$emit('close', null);
    }
  }
}
</script>
